var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.companyIsInactive
        ? _c("Gs1AlertCompanyInactive", {
            attrs: {
              gs1Id: _vm.gs1Id,
              gtinsVerifiedResponse: this.gtinsVerifiedResponse,
              glnsVerifiedResponse: this.glnsVerifiedResponse,
              mainLicensesVerifiedResponse: this.mainLicensesVerifiedResponse
            }
          })
        : _vm.saveGet(_vm.product, false, "isComplete")
        ? _c("gs1-alert-verified", {
            attrs: {
              companyName: _vm.saveGet(
                this.gtinsVerifiedResponse.gs1Licence,
                "",
                "licenseeName"
              ),
              gs1Id: _vm.saveGet(_vm.product, "", "gtin")
            }
          })
        : _c(
            "gs1-alert",
            {
              attrs: {
                alertClass: "success",
                iconClass: "fa fa-check-circle color-forest"
              }
            },
            [
              _c("p", [
                _vm._v(
                  "\n      " +
                    _vm._s(
                      _vm.$t("alert.some_data.title", {
                        company: _vm.saveGet(
                          this.gtinsVerifiedResponse.gs1Licence,
                          "",
                          "licenseeName"
                        ),
                        epc: _vm.gs1Id
                      })
                    ) +
                    "\n    "
                )
              ]),
              _vm._v(" "),
              _c(
                "i18n",
                {
                  staticClass: "small",
                  attrs: { path: "alert.some_data.message", tag: "p" }
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: "https://www.gs1-germany.de/service/kontakt/",
                        target: "_blank",
                        rel: "noopener"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("alert.some_data.contact_gs1")))]
                  )
                ]
              )
            ],
            1
          ),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-12 col-xs-12" }, [
          _c(
            "ul",
            {
              staticClass: "nav nav-tabs",
              staticStyle: { "padding-left": "0px" },
              attrs: { role: "tablist" }
            },
            [
              _vm.product
                ? _c(
                    "li",
                    {
                      class: _vm.productActive,
                      attrs: { role: "presentation" }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "#product",
                            role: "tab",
                            "data-toggle": "tab"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("product")) +
                              "\n          "
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.licence
                ? _c(
                    "li",
                    {
                      class: _vm.licenceActive,
                      attrs: { role: "presentation" }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "#company",
                            role: "tab",
                            "data-toggle": "tab"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("company")) +
                              "\n          "
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.digitalLocation
                ? _c(
                    "li",
                    {
                      class: _vm.digitalLocationActive,
                      attrs: { role: "presentation" }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "#digital",
                            role: "tab",
                            "data-toggle": "tab"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("digital_location")) +
                              "\n          "
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.functionType
                ? _c(
                    "li",
                    {
                      class: _vm.functionTypeActive,
                      attrs: { role: "presentation" }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "#functionType",
                            role: "tab",
                            "data-toggle": "tab"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("function")) +
                              "\n          "
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.legalEntity
                ? _c(
                    "li",
                    {
                      class: _vm.legalEntityActive,
                      attrs: { role: "presentation" }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "#legal",
                            role: "tab",
                            "data-toggle": "tab"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("legal_entity")) +
                              "\n          "
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.fixedPhysicalLocation
                ? _c(
                    "li",
                    {
                      class: _vm.fixedPhysicalLocationActive,
                      attrs: { role: "presentation" }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "#fixed",
                            role: "tab",
                            "data-toggle": "tab"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("fixed_physical_location")) +
                              "\n          "
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.mobilePhysicalLocation
                ? _c(
                    "li",
                    {
                      class: _vm.mobilePhysicalLocationActive,
                      attrs: { role: "presentation" }
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: "#mobile",
                            role: "tab",
                            "data-toggle": "tab"
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.$t("mobile_physical_location")) +
                              "\n          "
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "tab-content" }, [
            _vm.product
              ? _c(
                  "div",
                  {
                    staticClass: "tab-pane active",
                    class: _vm.productActive,
                    staticStyle: { width: "100%", "overflow-x": "auto" },
                    attrs: { role: "tabpanel", id: "product" }
                  },
                  [
                    _c("Product", {
                      attrs: {
                        product: _vm.product,
                        status: _vm.productStatus,
                        linkSet: _vm.gtinLinkSet
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.licence
              ? _c(
                  "div",
                  {
                    staticClass: "tab-pane",
                    class: _vm.licenceActive,
                    staticStyle: { width: "100%", "overflow-x": "auto" },
                    attrs: { role: "tabpanel", id: "company" }
                  },
                  [
                    _c("Licence", {
                      attrs: {
                        "show-map": true,
                        licence: _vm.licence,
                        mainLicensesVerifiedResponse:
                          _vm.mainLicensesVerifiedResponse
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.digitalLocation
              ? _c(
                  "div",
                  {
                    staticClass: "tab-pane",
                    staticStyle: { width: "100%", "overflow-x": "auto" },
                    attrs: { role: "tabpanel", id: "digital" }
                  },
                  [
                    _c("DigitalLocation", {
                      attrs: {
                        digitalLocation: _vm.digitalLocation,
                        status: _vm.digitalLocationStatus,
                        linkSet: _vm.glnLinkSet
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.functionType
              ? _c(
                  "div",
                  {
                    staticClass: "tab-pane",
                    staticStyle: { width: "100%", "overflow-x": "auto" },
                    attrs: { role: "tabpanel", id: "functionType" }
                  },
                  [
                    _c("FunctionType", {
                      attrs: {
                        "show-map": true,
                        functionType: _vm.functionType,
                        status: _vm.functionTypeStatus,
                        linkSet: _vm.glnLinkSet
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.legalEntity
              ? _c(
                  "div",
                  {
                    staticClass: "tab-pane",
                    staticStyle: { width: "100%", "overflow-x": "auto" },
                    attrs: { role: "tabpanel", id: "legal" }
                  },
                  [
                    _c("LegalEntity", {
                      attrs: {
                        "show-map": true,
                        legalEntity: _vm.legalEntity,
                        status: _vm.legalEntityStatus,
                        linkSet: _vm.glnLinkSet
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.fixedPhysicalLocation
              ? _c(
                  "div",
                  {
                    staticClass: "tab-pane",
                    staticStyle: { width: "100%", "overflow-x": "auto" },
                    attrs: { role: "tabpanel", id: "fixed" }
                  },
                  [
                    _c("FixedPhysicalLocation", {
                      attrs: {
                        "show-map": true,
                        fixedPhysicalLocation: _vm.fixedPhysicalLocation,
                        status: _vm.fixedPhysicalLocationStatus,
                        linkSet: _vm.glnLinkSet
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.mobilePhysicalLocation
              ? _c(
                  "div",
                  {
                    staticClass: "tab-pane",
                    staticStyle: { width: "100%", "overflow-x": "auto" },
                    attrs: { role: "tabpanel", id: "mobile" }
                  },
                  [
                    _c("MobilePhysicalLocation", {
                      attrs: {
                        mobilePhysicalLocation: _vm.mobilePhysicalLocation,
                        status: _vm.mobilePhysicalLocationStatus,
                        linkSet: _vm.glnLinkSet
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ])
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "footnote" }, [
        _vm._v(
          "\n    " +
            _vm._s(
              _vm.$t("provided_by", [
                _vm.saveGet(
                  this.gtinsVerifiedResponse.gs1Licence,
                  "",
                  "licenseeName"
                )
              ])
            ) +
            "\n  "
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dd2237d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd2237d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ResultData.vue
// module id = null
// module chunks = 